// tslint:disable: naming-convention
import { Action } from '@ngrx/store';
import { PlausibilitaetEntity } from '../../../entities/mdqx/plausibilitaet.entity';

export enum PlausibilitaetActionTypes {
    GetPlausibilitaetenRequest = '[Plausibilitaeten] Get Request',
    GetPlausibilitaetenResponse = '[Plausibilitaeten] Get Response',
}

export class GetPlausibilitaetenRequest implements Action {
    readonly type = PlausibilitaetActionTypes.GetPlausibilitaetenRequest;
}

export class GetPlausibilitaetenResponse implements Action {
    readonly type = PlausibilitaetActionTypes.GetPlausibilitaetenResponse;
    constructor(public Payload: PlausibilitaetEntity[]) {}
}

export type PlausibilitaetActions = GetPlausibilitaetenRequest | GetPlausibilitaetenResponse;
